module.exports = __webpack_public_path__ + "dojo.3_1tRm1p.png";